import React, { useEffect, useState, useRef } from "react";
import { CircleMarker } from "react-leaflet";

export default function AnimatedMarker({ position, children, duration = 300 }) {
  const [pos, setPos] = useState(position);
  const rafRef = useRef(null);
  const fromRef = useRef(position);

  useEffect(() => {
    if (!position) return;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    const from = fromRef.current || position;
    const to = position;
    const start = performance.now();
    const step = (t) => {
      const elapsed = t - start;
      const p = Math.min(1, elapsed / duration);
      const lat = from[0] + (to[0] - from[0]) * p;
      const lng = from[1] + (to[1] - from[1]) * p;
      setPos([lat, lng]);
      if (p < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        fromRef.current = to;
        rafRef.current = null;
      }
    };
    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [position, duration]);

  if (!pos) return null;

  return (
    <CircleMarker
      center={pos}
      radius={10}
      pathOptions={{
        color: "#C86B4E",
        weight: 4,
        fillColor: "white",
        fillOpacity: 1,
      }}
    >
      {children}
    </CircleMarker>
  );
}
